module.exports = __webpack_public_path__ + "img/Colorization10.696a2360.webp";